import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";

//ANT DESIGN IMPORTS
import {
  Button,
  Card,
  Col,
  Flex,
  Form,
  Row,
  Spin,
  Steps,
  Typography,
} from "antd";

//PROJECT IMPORTS
import styles from "../../../assets/styles/styles";
import { showCheckerApprovalModal } from "../../../components/CheckerModal";
import CustomButton from "../../../components/custom/CustomButton";
import MainLayout from "../../../components/layouts/MainLayout";
import TopContent from "../../../components/layouts/TopContent";
import cnt from "../../../services/definedConstant";
import { BOM } from "../../../services/definedMethod";
import { apiConfig, labelConfig, staticConfig } from "../systemAdmin.config";
import BranchAuthorizationForm from "./components/BranchAuthorizationForm";
import BranchLimitForm from "./components/BranchLimitsForm";
import BranchTransactionLimitsForm from "./components/BranchTransactionLimitsForm";
import Preview from "./components/Preview";

const AddSYA0400 = (props) => {
  //DECLARED VARIABLES
  const { userData } = props;
  const { Text, Title } = Typography;
  const { session } = userData;
  const navigate = useNavigate();
  const [useForm] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [current, setCurrent] = useState(0);
  const [configureLimitTableSource, setConfigurelimitTableSource] = useState(
    [],
  );
  const [configureTransactionTableSource, setConfigureTransactionTableSource] =
    useState([]);
  const [officeRawData, setOfficeRawData] = useState(null);
  const [branchOpRawData, setBranchOpRawData] = useState(null);
  const [officeData, setOfficeData] = useState([]);
  const [codeValueData, setCodeValueData] = useState([]);
  const [transactionCurrencyData, setTransactionCurrencyData] = useState([]);
  const [currencyData, setCurrencyData] = useState([]);
  const [templateConfigDetail, setTemplateConfigDetail] = useState({});
  const [LimitCount, setLimitCount] = useState(0);
  const [transactionCount, setTransactionCount] = useState(0);

  // ENDPOINT DECLARED VARIABLES
  const [formData, setFormData] = useState({
    authForm: null,
    branchCcyRestrConfs: null,
    branchOperationTransactionType: null,
  });

  useEffect(() => {
    getOffices();
    getBranchOpConfig();
    getCurrencies();
    getTellerTransactionType();
  }, []);

  // Once both datasets are loaded, compute unconfigured offices
  useEffect(() => {
    if (!officeRawData || !branchOpRawData) return;

    const configuredOfficeIds = new Set(
      branchOpRawData.map((b) => b.officeId?.id),
    );

    console.log(configuredOfficeIds);

    const unconfigured = officeRawData.filter(
      (office) => !configuredOfficeIds.has(office.id),
    );

    setOfficeData(
      unconfigured.map((office) => ({
        value: office.id,
        label: office.name,
      })),
    );
  }, [officeRawData, branchOpRawData]);

  const onFinishAuthForm = (values) => {
    // console.log(values);

    setFormData({ ...formData, authForm: values });
    setCurrent(current + 1);
  };

  const onFinishLimitsForm = (values) => {
    // console.log(values);
    // console.log(configureLimitTableSource);

    const tempNewCurrencyData = configureLimitTableSource.map((configItem) => {
      const matchedCurrency = currencyData?.find(
        (currencyItem) => currencyItem.value === configItem.currencyCode,
      );

      return {
        value: configItem.currencyCode,
        label: matchedCurrency?.label || configItem.currencyCode,
      };
    });

    // console.log(tempNewCurrencyData);
    setTransactionCurrencyData(tempNewCurrencyData);

    let tempConfigData = [];

    configureLimitTableSource.forEach((element, index) => {
      tempConfigData.push({
        authThresholdAmount: element.authThresholdAmount,
        currencyCode: element.currencyCode,
        transactionLimit: element.transactionLimit,
        locale: "en",
        branchOperationTransactionTypes: [],
      });
    });

    setFormData({
      ...formData,
      branchCcyRestrConfs: configureLimitTableSource,
    });
    setCurrent(current + 1);
  };

  const onFinishTransactionForm = (values) => {
    console.log(values);
    console.log(configureTransactionTableSource);

    let tempConfigData = [];

    configureTransactionTableSource.forEach((element, index) => {
      tempConfigData.push({
        transactionType: element.authThresholdAmount,
        currencyCode: element.currencyCode,
        transactionTypeLimit: element.transactionLimit,
        locale: "en",
      });
    });

    setFormData({
      ...formData,
      branchOperationTransactionType: configureTransactionTableSource,
    });
    setCurrent(current + 1);
  };

  const forms = [
    <BranchAuthorizationForm
      onFinish={onFinishAuthForm}
      form={useForm}
      formData={formData.authForm}
      officeData={officeData}
    />,

    <BranchLimitForm
      onFinish={onFinishLimitsForm}
      form={useForm}
      formData={formData.branchCcyRestrConfs}
      userData={userData}
      isLoading={isLoading}
      setIsLoading={setIsLoading}
      configureLimitTableSource={configureLimitTableSource}
      setConfigurelimitTableSource={setConfigurelimitTableSource}
      LimitCount={LimitCount}
      setLimitCount={setLimitCount}
      currencyData={currencyData}
    />,

    <BranchTransactionLimitsForm
      onFinish={onFinishTransactionForm}
      form={useForm}
      formData={formData.branchOperationTransactionType}
      userData={userData}
      isLoading={isLoading}
      setIsLoading={setIsLoading}
      codeValueData={codeValueData}
      configureTransactionTableSource={configureTransactionTableSource}
      setConfigureTransactionTableSource={setConfigureTransactionTableSource}
      transactionCount={transactionCount}
      setTransactionCount={setTransactionCount}
      currencyData={transactionCurrencyData}
    />,

    <Preview
      formData={formData}
      currencyData={currencyData}
      officeData={officeData}
      configureLimitTableSource={configureLimitTableSource}
      configureTransactionTableSource={configureTransactionTableSource}
    />,
  ];

  const isLastStep = current === forms.length - 1;

  const nextButtonClick = () => {
    useForm.submit();
  };

  const prevButtonClick = () => {
    setCurrent(current - 1);
  };

  const getOffices = () => {
    setIsLoading(true);
    BOM.FetchReqAction({ session }, apiConfig.Office, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        setIsLoading(false);
        return;
      }
      setOfficeRawData(res || []);
      setIsLoading(false);
    });
  };

  const getBranchOpConfig = () => {
    setIsLoading(true);
    BOM.FetchReqAction({ session }, apiConfig.Branchoprconfig, (err, res) => {
      if (err) {
        BOM.AlertMsg(
          cnt.DANGER,
          err?.errors[0]?.defaultUserMessage || err.defaultUserMessage,
        );
        setIsLoading(false);
        return;
      }
      setBranchOpRawData(res || []);
      setIsLoading(false);
    });
  };

  const getCurrencies = () => {
    setIsLoading(true);

    const url = apiConfig.Currencies;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objDetails = res;
        let tempCurrencyData = [];

        objDetails?.selectedCurrencyOptions?.forEach((element) => {
          tempCurrencyData.push({
            value: element.code,
            label: element.displayLabel,
          });
        });

        setCurrencyData(tempCurrencyData);

        setIsLoading(false);
      }
    });
  };

  const getTellerTransactionType = () => {
    setIsLoading(true);

    const url = `${apiConfig.Codes}/codevalue/TellerTransactionType`;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objList = res;

        getCodeValues(objList);

        setIsLoading(false);
      }
    });
  };

  const getCodeValues = (param) => {
    setIsLoading(true);

    const url = `${apiConfig.Codes}/${param.id}/codevalues`;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objDetails = res;
        let tempCodeValueData = [];
        console.log(res);

        objDetails?.forEach((element) => {
          tempCodeValueData.push({
            value: element.id,
            label: element.name,
          });
        });

        setCodeValueData(tempCodeValueData);

        setIsLoading(false);
      }
    });
  };

  const onSubmit = () => {
    const branchCcyRestrConfs = formData.branchCcyRestrConfs.map((conf) => {
      const matchingOperations = formData.branchOperationTransactionType
        .filter((op) => op.currencyCode === conf.currencyCode)
        .map((op) => ({
          branchOperationTransactionType: {
            locale: op.locale || "en",
            transactionType: op.transactionType,
            transactionTypeLimit:
              op.transactionTypeLimit || conf.transactionLimit,
          },
        }));

      return {
        branchCcyRestrConf: {
          locale: conf.locale || "en",
          currencyCode: conf.currencyCode,
          authThresholdAmount: conf.authThresholdAmount.toString(),
          transactionLimit: conf.transactionLimit.toString(),
          branchOperationTransactionTypes: matchingOperations,
        },
      };
    });

    let formValues = {
      ...formData.authForm,
      branchCcyRestrConfs,
    };

    const body = {
      ...formValues,
      locale: "en",
      method: "POST",
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      apiConfig.Branchoprconfig,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, labelConfig.newConfigurationMsg);
          navigate("/SYA0400");
          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          navigate("/SYA0400");
          setIsLoading(false);
        },
      },
    );
  };

  function onCancel() {
    navigate("/SYA0400", { replace: false });
  }

  return (
    <MainLayout isEnableRightSidebar={false} onSave={onSubmit}>
      <TopContent
        pageTitle={labelConfig.newBranchConfiguration}
        pageItems={staticConfig.newBranchConfigurationBreadcrumbItems}
      />
      <Spin spinning={isLoading} tip="Loading..." size="large">
        <Card title={"Branch Config..."} style={styles.cardWrapper}>
          <div>
            <Row
              gutter={{
                xs: 8,
                sm: 16,
                md: 24,
                lg: 32,
              }}
              style={{ marginBottom: 25 }}
            >
              <Col span={24}>
                <Row style={{ justifyContent: "space-between" }}>
                  <Card style={styles.cardSteps}>
                    <Steps
                      current={current}
                      onChange={setCurrent}
                      direction="vertical"
                      style={{ height: "600px" }}
                      items={[
                        {
                          title: <Text strong>Branch Authorization</Text>,
                        },
                        {
                          title: <Text strong>Branch Limits</Text>,
                        },
                        {
                          title: <Text strong>Branch Transaction Limits</Text>,
                        },
                        {
                          title: <Text strong>Preview</Text>,
                        },
                      ]}
                    />
                  </Card>
                  {/* Form Section */}
                  <Card style={styles.cardStepDisplay}>
                    <div>{forms[current]}</div>
                    {/* </Form> */}
                  </Card>
                </Row>
              </Col>
            </Row>

            {/* Submitt section */}
            <Card
              style={{
                marginBottom: 25,
                boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
                borderRadius: 20,
                padding: 5,
              }}
            >
              <Flex
                justify="space-between"
                style={{ paddingLeft: "20px", paddingRight: "40px" }}
              >
                {current === 0 && (
                  <Button
                    style={{
                      width: "12%",
                      height: "15%",
                      backgroundColor: "white",
                      boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                      borderRadius: 20,
                      color: "black",
                    }}
                    onClick={onCancel}
                  >
                    Cancel
                  </Button>
                )}
                {current > 0 && (
                  <CustomButton
                    content={labelConfig.previous}
                    className="of-primaryBtnColor"
                    style={{
                      width: "10%",
                      boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                    }}
                    onClick={prevButtonClick}
                  />
                )}
                {!isLastStep && (
                  <CustomButton
                    content={labelConfig.next}
                    className="of-primaryBtnColor"
                    style={{
                      width: "10%",
                      boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                    }}
                    onClick={nextButtonClick}
                  />
                )}
                {BOM.HasPermission("CREATE_SAVINGSPRODUCT") && isLastStep && (
                  <CustomButton
                    content="Submit"
                    style={{
                      width: "10%",
                      marginLeft: "auto",
                      boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                    }}
                    onClick={onSubmit}
                    backgroundColor="#fff"
                    colorText="black"
                    hoverBackground="#F5F5F5"
                  />
                )}
              </Flex>
            </Card>
          </div>
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(AddSYA0400);
